// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import ClipboardController from "./clipboard_controller"
import InlineItemCreatorController from "./inline_item_creator_controller"
import InventoryStepperController from "./inventory_stepper_controller"
import RoomListController from "./room_list_controller"
import RoomManagerController from "./room_manager_controller"
import SelectController from "./select_controller"
import SortableController from "./sortable_controller"

application.register("inline-item-creator", InlineItemCreatorController)
application.register("clipboard", ClipboardController)
application.register("inventory-stepper", InventoryStepperController)
application.register("room-list", RoomListController)
application.register("room-manager", RoomManagerController)
application.register("select", SelectController)
application.register("sortable", SortableController)
application.register("nested-form", RailsNestedForm)
